import { curry } from 'lib/util'
import { seqModuleAdapterAlertEventsDispatch } from 'app/_shared/events/notification'

/**
 * Reads all notifications
 *
 * @type {(function(...[*]): (*))|*}
 */
const read = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'read',
    detail,
    callback,
    true,
  )(e),
)

/**
 * Opens a specific notification
 *
 * @type {(function(...[*]): (*))|*}
 */
const show = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'show',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Updates the incoming notification by toggling the read/unread property
 *
 * @type {(function(...[*]): (*))|*}
 */
const update = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'update',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Sets all notifications as read
 *
 * NOTE: Does not, unlike {@link update}, toggle the `read` state of the notifications. So there
 * is no 'set all as unread' functionality.
 *
 * @type {(function(...[*]): (*))|*}
 */
const updateAll = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'updateAll',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Deletes all notifications
 *
 * @type {(function(...[*]): (*))|*}
 */
const deleteAll = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'deleteAll',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Deletes the incoming notification
 *
 * @type {(function(...[*]): (*))|*}
 */
const remove = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'delete',
    detail,
    callback,
    false,
  )(e),
)

/**
 * Sets the adapters group data to the incoming data
 *
 * @type {(function(...[*]): (*))|*}
 */
const set = curry(
  async (module, component, detail, callback, e) => await seqModuleAdapterAlertEventsDispatch(
    module,
    'set',
    detail,
    callback,
    false,
  )(e),
)

const alertEvents = {
  read,
  show,
  set,
  update,
  updateAll,
  remove,
  deleteAll,
}

export {
  alertEvents as default,
  read,
  show,
  set,
  update,
  updateAll,
  remove,
  deleteAll,
}
